import { useSearchBox } from 'react-instantsearch';

export function VirtualSearchBox(props: any) {
  useSearchBox(props);

  return null;
}
